import { PluginsUIPlugin } from '@stereograph/teiaviewer-plugins-ui-react';

import {
  Toolbar, ToolbarProps,
  ToolbarItemGroup,
} from '@stereograph/teiaviewer-viewport-react';

export const AppToolbar = (props: ToolbarProps) => {
  return (
    <Toolbar {...props}>
      <ToolbarItemGroup>
        <PluginsUIPlugin.ToolbarItems.NavigationGraphToolbarItem />
      </ToolbarItemGroup>
    </Toolbar>
  );
};

